import { StoreInterface } from '../../../core/interfaces/store/store-interface';
import {
  ProviderGroupEnum,
  providerSettingsFunction,
} from '@component-library';

export const getStoreCategoryMapping = (
  store: StoreInterface,
  categoryId: string,
  marketplaceIdentity: number,
  providerId: string
) => {
  const providerSettings = providerSettingsFunction(marketplaceIdentity);

  const storeFoundCategoryMapping = store?.categories?.base
    ?.filter((category) => category.CategoryAttributeMappings.length > 0)
    ?.find((category) => category.Id === categoryId)
    ?.CategoryAttributeMappings?.find((categoryMapping) => {
      if (providerSettings?.providerGroup === ProviderGroupEnum.Marketplace) {
        return categoryMapping.MarketplaceIdentity === marketplaceIdentity;
      }
      return (
        categoryMapping.MarketplaceIdentity === marketplaceIdentity &&
        categoryMapping.ProviderId === providerId
      );
    });

  return storeFoundCategoryMapping;
};

export const getStoreBrandMapping = (
  store: StoreInterface,
  brandId: string,
  marketplaceIdentity: number,
  providerId: string
) => {
  const providerSettings = providerSettingsFunction(marketplaceIdentity);

  const storeBrandMapping = store?.brands.base
    ?.filter((brand) => brand.Mappings.length > 0)
    ?.find((brand) => brand.Id === brandId)
    ?.Mappings?.find((brandMapping) => {
      if (providerSettings?.providerGroup === ProviderGroupEnum.Marketplace) {
        return brandMapping.MarketplaceIdentity === marketplaceIdentity;
      }
      return (
        brandMapping.MarketplaceIdentity === marketplaceIdentity &&
        brandMapping.ProviderId === providerId
      );
    });

  return storeBrandMapping;
};
